module.exports = __webpack_public_path__ + "img/fjy.ef07500c.png";